import Redux from 'redux';
import { ProfileState, ProfileActionTypes, PROFILE_LOADING, PROFILE_SUCCESS, PROFILE_FAILURE, PROFILE_SET_STATUS } from './types';
import { LOGIN_CLEAR_PRELOADED_DATA } from '$/store/login/types';

const initialState: ProfileState = {
  isLoading: false,
  profile: undefined,
};

const profileReducer: Redux.Reducer<ProfileState> = (
  state = initialState,
  action: ProfileActionTypes
): ProfileState => {
  switch (action.type) {
    case LOGIN_CLEAR_PRELOADED_DATA:
      return initialState;
    case PROFILE_LOADING:
      return {
        ...state,
        isLoading: true,
        loadingError: undefined,
      };
    case PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        profile: action.payload,
        loadingError: undefined,
      };
    case PROFILE_FAILURE:
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        profile: undefined,
      };
    case PROFILE_SET_STATUS:
      return {
        ...state,
        profile: state.profile ? { ...state.profile, status: action.payload } : state.profile,
      };
    default:
      return state;
  }
};

export default profileReducer;
